import * as Sentry from '@sentry/react'
import type { ChatMessage } from '../../shared/types/chat'
import type { FlagType } from './flagTypes'

interface ReportFlagInput {
  message: ChatMessage
  flagType: FlagType
  comment?: string
  conversationId: string | null
  recentMessages: ChatMessage[]
}

export function reportFlag({
  message,
  flagType,
  comment,
  conversationId,
  recentMessages,
}: ReportFlagInput) {
  const trimmedComment = comment?.trim() || undefined

  Sentry.captureMessage(`[chat-flag] ${flagType} (${message.type})`, {
    level: 'warning',
    tags: {
      feature: 'chat-flag',
      flag_type: flagType,
      conversation_id: conversationId ?? 'unknown',
      message_id: message.id,
      message_type: message.type,
    },
    extra: {
      url: typeof window !== 'undefined' ? window.location.href : undefined,
      comment: trimmedComment,
      flagged_content: message.content ?? '',
      flagged_timestamp: message.timestamp,
      recent_messages: recentMessages.map(m => ({
        id: m.id,
        type: m.type,
        timestamp: m.timestamp,
        content: (m.content ?? '').slice(0, 500),
      })),
    },
  })
}
